
import { iGamDiscusstionModel } from '@/interface/game-discussion-manage';
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() visible!: boolean;
  @Prop() detailInfo!: iGamDiscusstionModel;
  mounted() {
    // console.log('sdfsdfj');
  }
  handleClose() {
    this.$emit('close');
  }
}
